import { useEffect, Component } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Products from "@/components/Products";
import Stats from "@/components/Stats";
import Quality from "@/components/Quality";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="flex min-h-screen items-center justify-center bg-obsidian font-mono text-sm uppercase tracking-[0.25em] text-slate-400">
                    Something went wrong — please refresh.
                </div>
            );
        }
        return this.props.children;
    }
}

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <ErrorBoundary>
            <div className="bg-obsidian font-body text-slate-100 antialiased">
                <Nav />
                <main>
                    <Hero />
                    <Marquee />
                    <About />
                    <Products />
                    <Stats />
                    <Quality />
                    <Contact />
                </main>
                <Footer />
                <Toaster
                    position="bottom-right"
                    theme="dark"
                    toastOptions={{
                        style: {
                            background: "#18202C",
                            border: "1px solid #2A3648",
                            color: "#F8FAFC",
                            borderRadius: 0,
                            fontFamily: "JetBrains Mono, monospace",
                            fontSize: "12px",
                        },
                    }}
                />
            </div>
        </ErrorBoundary>
    );
}

export default App;
